import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import routes from "../../assets/apiRoutes.json";
import { Button } from "devextreme-react/button";
import Form from "devextreme-react/form";
import { RadioGroup } from "devextreme-react/radio-group";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ArrayStore from "devextreme/data/array_store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { SelectBox } from "devextreme-react/select-box";
import { HubConnectionBuilder } from "@microsoft/signalr";
import Popup from "devextreme-react/popup";
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';

import { alert } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import Accordion from 'devextreme-react/accordion';
import ReportFilter from "./ReportFilter";
import ReportViewer from "./ReportViewer";
import { downloadReportFile } from "../../common/Utils";
import { getApiErrorMessage } from "../../common/concurrency";
import { MESSAGES } from "../../common/Messages";

const selectBox = React.createRef();
const selectBoxMacro = React.createRef();
const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];

const fileFormats = ["PDF", "XLS", "XLSX", "CSV"];

let accessToken = "";
let ignoreMacroSelectionChange = false;

class Report extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.gridRefs = {};
    this.state = {
      animationDuration: 300,
      selectedItems: searchpanel,
      loadIndicatorVisible: false,
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
      connection: null,
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      generatedFileName: "",
      isDocViewerVisible: false,
      docViewerReportName: "",
      report: {
        key: "",
        name: "",
        fullName: "",
        formatName: "",
        macroName: "",
        fileFormat: "PDF",
        tabText: "",
        ignoreCompany: false,
        parameterList: [],
        queryParameters: [],
        whereInfoList: [],
        filterWhereInfoList: [
          /* {default:false,
          displayLabel : "Activity",
          fieldName: "ACTIVITY",
          fieldType: 0,
          from : null,
          group : 0,
          include : 0,
          items: null,
          lookupName : null,
          operation : 0,
          orderBy : 0,
          origin :  "CAACTIVITY.ACTIVITY",
          persistent : false,
          position : 0,
          prefix : 0,
          to : null,
          visible : true} */
        ],
        subreportList: []
      },
      formData: {},
      formItems: [],
    };

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    this.state.connection = newConnection;

    if (this.state.connection) {
      this.state.connection
        .start()
        .then((result) => {
          console.log("Connected!");

          this.state.connection.on("ReceiveMessage", (message) => {
            this.setState({
              generatedFileName: message.message,
              isGetReportPopupVisible: true,
              isReportInProgressPopupVisible: false,
            });
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }

    this.reportFormatDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFormats}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });

    this.selectionChanged = this.selectionChanged.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.openReportViewer = this.openReportViewer.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.handleReportFormatChanged = this.handleReportFormatChanged.bind(this);
    this.handleReportMacroChanged = this.handleReportMacroChanged.bind(this);
    this.fileFormatChanged = this.fileFormatChanged.bind(this);
    this.loadReport = this.loadReport.bind(this);
    this.loadReport();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.Name !== this.props.Name) {
      this.loadReport();
    }
  }
  download = () => {
    downloadReportFile(this.state.generatedFileName, accessToken);
  };

  renderPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={this.closeGetReportPopup} className="report-btn">
          Close
        </Button>
        <Button onClick={this.download} className="report-btn ml-3">
          Download Report
        </Button>
      </div>
    );
  };

  renderReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button
          onClick={this.closeReportInProgressPopup}
          className="report-btn"
        >
          Close
        </Button>
      </div>
    );
  };

  closeGetReportPopup = () => {
    this.setState({
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
    });
  };

  closeReportInProgressPopup = () => {
    this.setState({
      isReportInProgressPopupVisible: false,
    });
  };
  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems
    });
  }
  render() {
    /* Opt-in, and off unless a caller asks for it: every report page renders with embedded false and
       is unaffected. Set it when hosting this component inside a dialog (ItemsWithUnavailableQuantities
       Print menu). ReportFilter then pins the Available Fields list beside the criteria grid and sizes
       both panes from paneHeight, instead of hiding the list behind a drawer whose height comes from
       calc(100vh - <page chrome>) classes - those measure the browser window, so in a dialog the drawer
       has no room to open into and its menu button reads as dead. CommonReport forwards the same two
       props for the same reason. */
    const embedded = this.props.embedded === true;
    return (
      <div className="h-100 m-0" style={{ height: '100%',overflowY: 'hidden' }}>
        <div className="row">
          <div className="col-md-12 main-page">
            <div id="accordion" >
              <Accordion
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={this.state.animationDuration}
                selectedItems={this.state.selectedItems}
                onSelectionChanged={this.selectionChanged}
                itemTitleRender={() => (
                  <Toolbar className="accordian-toolbar">
                    <Item location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {this.props.Title}
                        </h6>
                      </div>
                    </Item>
                    <Item location="after">
                      <RadioGroup
                        style={{ marginRight: "10px" }}
                        items={fileFormats}
                        value={this.state.report.fileFormat}
                        layout="horizontal"
                        onValueChanged={this.fileFormatChanged}
                      />
                    </Item>
                    <Item location="after">
                      <Button className="accordianButton" onClick={this.previewButtonClicked} type="default">
                        <LoadIndicator
                          style={{
                            height: "20px",
                            width: "20px",
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                          visible={this.state.loadIndicatorVisible}
                        />
                        <span className="dx-button-text">Preview</span>
                      </Button>
                    </Item>
                    <Item location="after" >
                      <Button className="accordianButton"
                        text="Reset"
                        onClick={this.resetButtonClicked}
                      />
                    </Item>
                    {/* <Item location="after" >
                      <Button className="accordianButton"
                        text="Report Viewer"
                        type="default"
                        onClick={this.openReportViewer}
                      />
                    </Item> */}
                  </Toolbar>
                )}
                itemRender={(itemProps) => (
                  <div>
                    <div className="row">
                      <div className="col-md-3 " style={{paddingRight:'0px'}}>
                        <SelectBox
                          ref={selectBox}
                          placeholder="Select a Format"
                          onValueChanged={this.handleReportFormatChanged}
                          defaultValue={this.state.report.formatName}
                          stylingMode='outlined' labelMode="static"
                          label="Format"
                        />
                      </div>
                      <div className="col-md-3 " style={{marginLeft:'5px'}}>
                        <SelectBox
                          ref={selectBoxMacro}
                          placeholder="Select a Macro"
                          onValueChanged={this.handleReportMacroChanged}
                          defaultValue={this.state.report.macroName}
                          stylingMode='outlined' labelMode="static"
                          label="Macro"
                        />
                      </div>
                      </div>
                      <div className="row accordianLastRow" style={{width:'98.6%'}}>
                      <div className="col-md-12">
                        <Form
                          id="form"
                          labelMode="static"
                          labelLocation="left"
                          stylingMode='outlined'
                          formData={this.state.formData}
                          items={this.state.formItems}
                          colCount={4}
                          style={{marginBottom:"-11px"}}
                        />
                        </div>
                      </div>

                  </div>


                )}
                id="accordion-container" className="accordion-height"
              />
            </div>
          </div>
        </div>
        <TabPanel deferRendering={false} showNavButtons={true} height={"auto"}>
          <TabItem title={this.state.report.tabText == "" || this.state.report.tabText == null ? "Available Fields" : this.state.report.tabText}>
            <ReportFilter selectedItems={this.state.selectedItems} formItems={this.state.formItems} whereInfoList={this.state.report.whereInfoList} gridRefs={this.gridRefs} rowIndex={0} embedded={embedded} paneHeight={this.props.paneHeight} />
          </TabItem>
          {this.state.report.subreportList.map((m, i) => (
            <TabItem key={i + 1} title={m.tabText}>
              <ReportFilter selectedItems={this.state.selectedItems} formItems={this.state.formItems} whereInfoList={m.whereInfoList} gridRefs={this.gridRefs} rowIndex={i+1} embedded={embedded} paneHeight={this.props.paneHeight} />
            </TabItem>
          ))}
        </TabPanel>
        
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isGetReportPopupVisible}
          // onHiding={this.handlePopupHidden}
          contentRender={this.renderPopup}
        />
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isReportInProgressPopupVisible}
          contentRender={this.renderReportInProgressPopup}
        />
        <Popup
          visible={this.state.isDocViewerVisible}
          onHiding={() => this.setState({ isDocViewerVisible: false, docViewerReportName: "" })}
          title="Report Viewer"
          showTitle={true}
          showCloseButton={true}
          width="90%"
          height="90%"
          dragEnabled={true}
          resizeEnabled={true}
          contentRender={() => (
            this.state.docViewerReportName ? (
              <ReportViewer reportName={this.state.docViewerReportName} />
            ) : null
          )}
        />
      </div>
    );
  }

  loadReport() {
    var that = this;
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${this.props.Name}&reportFullName=${this.props.FullName}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {

        for (
          var i = 0;
          res.data.filterWhereInfoList != null &&
          i < res.data.filterWhereInfoList.length;
          i++
        ) 
        {
          switch (res.data.filterWhereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                j++
              ) {

                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                }

                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        for (
          var i = 0;
          res.data.whereInfoList != null &&
          i < res.data.whereInfoList.length;
          i++
        ) 
        {
          switch (res.data.whereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                j++
              ) {

                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                }

                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        for (
          var i = 0;
          res.data.subreportList != null &&
          i < res.data.subreportList.length;
          i++
        ) 
        {
          for (
            var j = 0;
            res.data.subreportList[i].filterWhereInfoList != null &&
            j < res.data.subreportList[i].filterWhereInfoList.length;
            j++
          ) 
          {
            switch (res.data.subreportList[i].filterWhereInfoList[j].fieldType) {
              case 5: // Flag
                for (
                  var k = 0;
                  res.data.subreportList[i].filterWhereInfoList[j].items != null && k < res.data.subreportList[i].filterWhereInfoList[j].items.length;
                  k++
                ) {

                  if (res.data.subreportList[i].filterWhereInfoList[j].from == res.data.subreportList[i].filterWhereInfoList[j].items[k].value) {
                    res.data.subreportList[i].filterWhereInfoList[j].from = res.data.subreportList[i].filterWhereInfoList[j].items[k].text;
                  }

                  if (res.data.subreportList[i].filterWhereInfoList[j].to == res.data.subreportList[i].filterWhereInfoList[j].items[k].value) {
                    res.data.subreportList[i].filterWhereInfoList[j].to = res.data.subreportList[i].filterWhereInfoList[j].items[k].text;
                  }
                }
                break;
              default:
            }
          }
          
          for (
            var j = 0;
            res.data.subreportList[i].whereInfoList != null &&
            j < res.data.subreportList[i].whereInfoList.length;
            j++
          ) 
          {
            switch (res.data.subreportList[i].whereInfoList[j].fieldType) {
              case 5: // Flag
                for (
                  var k = 0;
                  res.data.subreportList[i].whereInfoList[j].items != null && k < res.data.subreportList[i].whereInfoList[j].items.length;
                  k++
                ) {

                  if (res.data.subreportList[i].whereInfoList[j].from == res.data.subreportList[i].whereInfoList[j].items[k].value) {
                    res.data.subreportList[i].whereInfoList[j].from = res.data.subreportList[i].whereInfoList[j].items[k].text;
                  }

                  if (res.data.subreportList[i].whereInfoList[j].to == res.data.subreportList[i].whereInfoList[j].items[k].value) {
                    res.data.subreportList[i].whereInfoList[j].to = res.data.subreportList[i].whereInfoList[j].items[k].text;
                  }
                }
                break;
              default:
            }
          }
        }

        // Check if lot code was passed via location state and update filter
        let reportData = res.data;
        if (that.props.location?.state?.lotCode && that.props.Name === "WMR0047") {
          // Find the Lot filter and set its value
          const filterWhereInfoList = [...(reportData.filterWhereInfoList || [])];
          const lotFilterIndex = filterWhereInfoList.findIndex(
            filter => filter.fieldName === "LotCode" || filter.displayLabel === "Lot"
          );
          if (lotFilterIndex >= 0) {
            filterWhereInfoList[lotFilterIndex] = {
              ...filterWhereInfoList[lotFilterIndex],
              from: that.props.location.state.lotCode
            };
            reportData = {
              ...reportData,
              filterWhereInfoList: filterWhereInfoList
            };
          }
        }

        if (Array.isArray(that.props.initialFilters) && that.props.initialFilters.length) {
          const filterWhereInfoList = [...(reportData.filterWhereInfoList || [])];
          that.props.initialFilters.forEach((initialFilter) => {
            if (
              initialFilter == null ||
              initialFilter.value === undefined ||
              initialFilter.value === null ||
              initialFilter.value === ""
            ) {
              return;
            }
            const filterIndex = filterWhereInfoList.findIndex(
              (filter) =>
                (initialFilter.fieldName && filter.fieldName === initialFilter.fieldName) ||
                (initialFilter.displayLabel && filter.displayLabel === initialFilter.displayLabel)
            );
            if (filterIndex >= 0) {
              filterWhereInfoList[filterIndex] = {
                ...filterWhereInfoList[filterIndex],
                from: initialFilter.value,
                ...(initialFilter.to !== undefined ? { to: initialFilter.to } : {}),
              };
            } else {
              filterWhereInfoList.push({
                default: false,
                displayLabel: initialFilter.displayLabel || initialFilter.fieldName || "",
                fieldName: initialFilter.fieldName || "",
                fieldType: initialFilter.fieldType !== undefined ? initialFilter.fieldType : 0,
                from: initialFilter.value,
                group: initialFilter.group !== undefined ? initialFilter.group : 0,
                include: initialFilter.include !== undefined ? initialFilter.include : 0,
                items: initialFilter.items || null,
                lookupName: initialFilter.lookupName || null,
                operation: initialFilter.operation !== undefined ? initialFilter.operation : 3,
                orderBy: initialFilter.orderBy !== undefined ? initialFilter.orderBy : 0,
                origin: initialFilter.origin || null,
                persistent: false,
                position: 0,
                prefix: initialFilter.prefix !== undefined ? initialFilter.prefix : 0,
                to: initialFilter.to !== undefined ? initialFilter.to : null,
                visible: initialFilter.visible !== undefined ? initialFilter.visible : true,
              });
            }
          });
          reportData = {
            ...reportData,
            filterWhereInfoList: filterWhereInfoList,
          };
        }

        that.setState({
          report: reportData,
        });

        var formData = new Object();

        var formItems = [];

        for (
          var i = 0;
          that.state.report.parameterList != null &&
          i < that.state.report.parameterList.length;
          i++
        ) {
          formData[that.state.report.parameterList[i].name] =
            that.state.report.parameterList[i].value;
          var formItem = new Object();
          formItem.dataField = that.state.report.parameterList[i].name;
          formItem.label = new Object();
          formItem.label.text = that.state.report.parameterList[i].label;
          switch (that.state.report.parameterList[i].parameterType) {
            case 1: // Integer
            case 2: // Decimal
              formItem.editorType = "dxNumberBox";
              break;
            case 3: // Boolean
              formItem.editorType = "dxCheckBox";
              break;
            case 4: // DateTime
              formItem.editorType = "dxDateBox";
              break;
            case 5: // Flag
              formItem.editorType = "dxSelectBox";
              formItem.editorOptions = new Object();
              formItem.editorOptions.items = [];

              for (
                var j = 0;
                j < that.state.report.parameterList[i].items.length;
                j++
              ) {
                var selectBoxItem = new Object();
                selectBoxItem.Value =
                  that.state.report.parameterList[i].items[j].value;
                selectBoxItem.Text =
                  that.state.report.parameterList[i].items[j].text;
                formItem.editorOptions.items.push(selectBoxItem);
              }

              formItem.editorOptions.displayExpr = "Text";
              formItem.editorOptions.valueExpr = "Value";
              break;
            default:
              formItem.editorType = "dxTextBox";
          }

          formItems.push(formItem);
        }

        that.setState({
          formData: formData,
        });

        that.setState({
          formItems: formItems,
        });

        var dataFilterDataSource = new ArrayStore({
          data: that.state.report.filterWhereInfoList,
          // key: "displayLabel",
        });

        this.gridRefs[0].instance().option("dataSource", dataFilterDataSource);

        for (
          var i = 0;
          that.state.report.subreportList != null &&
          i < that.state.report.subreportList.length;
          i++
        )
        {
          var subreportDataSource = new ArrayStore({
            data: that.state.report.subreportList[i].filterWhereInfoList,
            // key: "displayLabel",
          });

          this.gridRefs[i + 1].instance().option("dataSource", subreportDataSource);
        }

        axios
          .get(
            `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFormats}?reportName=${that.props.Name}`,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((res) => {
            var reportFormatDataSource = new ArrayStore({
              data: res.data,
            });

            selectBox.current.instance().option(
              "dataSource",
              reportFormatDataSource
            );
            selectBox.current.instance().option(
              "value",
              that.state.report.formatName
            );
          })
          .catch((err) => {
            console.log(err, "Error getting report format data");
          });

        axios
          .get(
            `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportMacros}?reportName=${that.props.Name}`,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((res) => {
            var reportMacroDataSource = new ArrayStore({
              data: res.data,
            });

            selectBoxMacro.current.instance().option(
              "dataSource",
              reportMacroDataSource
            );

            ignoreMacroSelectionChange = true;
            selectBoxMacro.current.instance().option(
              "value",
              that.state.report.macroName
            );
            ignoreMacroSelectionChange = false;

          })
          .catch((err) => {
            console.log(err, "Error getting report macro data");
          });
      })
      .catch((err) => {
        console.log(err, "Error getting report data");
        // Only an API failure is shown; an error thrown above while building the screen stays in the console.
        if (err && err.response) {
          notify(getApiErrorMessage(err, MESSAGES.ERROR_LOADING_REPORT), "error", 5000);
        }
      });
  }

  fileFormatChanged(e) {
    if(e?.event)
      e.event.stopPropagation();
    var report = { ...this.state.report };
    report.fileFormat = e.value;
    this.setState({ report });
  }

  handleReportFormatChanged(e) {
    var report = { ...this.state.report };
    report.formatName = e.value;
    this.setState({ report });
  }

  handleReportMacroChanged(e) {

    if (!ignoreMacroSelectionChange) {
      var report = { ...this.state.report };
      report.macroName = e.value;
      this.setState({ report });
      var that = this;

      axios.get
        (
          `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportDataByMacro}?macro=${report.macroName}&reportName=${this.props.Name}`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            }
          }
        )
        .then((result) => {
          if (result.data) {

            var formData = new Object();
            for (
              var i = 0;
              result.data.parameterList != null &&
              i < result.data.parameterList.length;
              i++
            ) {
              formData[result.data.parameterList[i].name] =
                result.data.parameterList[i].value;
            }

            that.setState({
              formData: formData,
            });

            var dataFilterDataSource = new ArrayStore({
              data: result.data.filterWhereInfoList,
              key: "displayLabel",
            });

            this.gridRefs[0].instance().option("dataSource", dataFilterDataSource);
            
            for (
              var i = 0;
              result.data.subreportList != null &&
              i < result.data.subreportList.length;
              i++
            )
            {
              var subreportDataSource = new ArrayStore({
                data: result.data.subreportList[i].filterWhereInfoList,
                // key: "displayLabel",
              });

              this.gridRefs[i + 1].instance().option("dataSource", subreportDataSource);
            }
          }

        });
    }
  }

  resetButtonClicked(e) {
    if(e?.event)
      e.event.stopPropagation();
    this.loadReport();
  }
  async openReportViewer(e) {
    if (e?.event) e.event.stopPropagation();

    // Save any pending edits in the filter grids
    for (let i = 0; i < this.gridRefs.length; i++) {
      await this.gridRefs[i].instance().saveEditData();
    }

    // Collect current parameter values (same as previewButtonClicked)
    for (
      var i = 0;
      this.state.report.parameterList != null &&
      i < this.state.report.parameterList.length;
      i++
    ) {
      this.state.report.parameterList[i].value =
        this.state.formData[this.state.report.parameterList[i].name];
    }

    // Force PDF format for the Document Viewer
    var originalFormat = this.state.report.fileFormat;
    this.state.report.fileFormat = "PDF";

    this.setState({ loadIndicatorVisible: true });

    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
        this.state.report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        this.setState({ loadIndicatorVisible: false });
        // Restore original format
        this.state.report.fileFormat = originalFormat;

        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data.isSuccess &&
          res.data.fileName
        ) {
          // Open the Document Viewer with the generated PDF
          // The "PDF:" prefix tells the backend to wrap the PDF in an XRPdfContent report
          this.setState({
            isDocViewerVisible: true,
            docViewerReportName: `PDF:${res.data.fileName}`,
          });
        } else {
          alert(
            "Cannot generate report. " + (res.data?.errorMessage || "Unknown error"),
            "Error"
          );
        }
      })
      .catch((err) => {
        this.setState({ loadIndicatorVisible: false });
        this.state.report.fileFormat = originalFormat;
        alert("Error generating report: " + (err.message || err), "Error");
      });
  }

  async previewButtonClicked(e) {
    if(e?.event)
      e.event.stopPropagation();
    for (let i = 0; i < this.gridRefs.length; i++) {
        await this.gridRefs[i].instance().saveEditData();
    }
    

    this.setState({
      loadIndicatorVisible: true,
    });

    for (
      var i = 0;
      this.state.report.parameterList != null &&
      i < this.state.report.parameterList.length;
      i++
    ) {
      this.state.report.parameterList[i].value =
        this.state.formData[this.state.report.parameterList[i].name];
    }

    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
        this.state.report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (window._env_.Generate_Report_From_Remote) {
          if (res.data.isSuccess) {
            this.setState({
              isGetReportPopupVisible: false,
              isReportInProgressPopupVisible: true,
            });
          } else {
            alert(
              "Cannot generate report. Error:  " + res.data.errorMessage,
              "Error"
            );
          }
        } else {
          if (
            res.hasOwnProperty("data") &&
            res.data != null &&
            res.data != undefined
          ) {
            if (res.data.isSuccess) {
              // Returned so the loader stays up until the file has downloaded.
              return downloadReportFile(res.data.fileName, accessToken);
            } else {
              alert(
                "Cannot generate report. Error:  " + res.data.errorMessage,
                "Error"
              );
            }
          } else {
            alert("Cannot generate report", "Error");
          }
        }
    })
      .finally(() => {
        this.setState({
          loadIndicatorVisible: false,
        });
      });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default withRouter(connect(mapStateToProps)(Report));
